import React from 'react';
import { getLifecycleStops, getLifecycleStopIndex } from './roMoney';

export default function LifecycleRail({ truck, settings }) {
  const stops = getLifecycleStops(truck, settings);
  const currentIdx = getLifecycleStopIndex(truck, settings);
  return (
    <div className="ro-rail">
      {stops.map((stop, i) => (
        <React.Fragment key={stop.id}>
          <div className={`ro-rail-step ${i < currentIdx ? 'past' : i === currentIdx ? 'current' : 'future'}`}>
            <div className="ro-rail-dot" />
            <span className="ro-rail-label">{stop.label}</span>
          </div>
          {i < stops.length - 1 && (
            <div className={`ro-rail-line ${i < currentIdx ? 'past' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
